export default __webpack_public_path__ + "static/media/logo.c79239c0.png";